import React, {useState} from 'react';
import TextField from '@mui/material/TextField';

// Grant funds input field
function InputFunds({onTotalChange, inputTotal, inputTotalFormat }) {
 
 const [isEditing, setIsEditing] = useState(false);

 const handleFocus = () => {
  setIsEditing(true);
};

const handleBlur = () => {
  setIsEditing(false);
};

  return (
    <div>
      <TextField
        label="Grant Funds Available"
        type="text"
        variant="outlined"
        value={isEditing ? inputTotal: `$${inputTotalFormat}`}
        onChange={onTotalChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        fullWidth 
      />
    </div>
  );
}

export default InputFunds;

